document.addEventListener("DOMContentLoaded", (e) => {
	console.log("page");
});
